module.exports = __webpack_public_path__ + "static/media/newsletter-december-2021-building-program.e7853545.jpg";